// extracted by mini-css-extract-plugin
export var center = "_4x-2";
export var clickableRow = "_4x-5";
export var expandedRow = "_4x-7";
export var hoverable = "_4x-4";
export var left = "_4x-1";
export var right = "_4x-3";
export var row = "_4x-0";
export var selectedRow = "_4x-6";
export var summaryRow = "_4x-8";